import { ThreadHeader } from '@frontend/thread-header';
import { theme } from '@frontend/theme';

export const ResponsiveContactInfo = ({ threadNamingIsEnabled }: { threadNamingIsEnabled: boolean }) => {
  const { variant } = ThreadHeader.useContext();

  return (
    <span
      css={{
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
        justifyContent: variant === 'small' ? 'center' : undefined,
        width: 'fit-content',
      }}
    >
      {threadNamingIsEnabled && <ThreadHeader.AssociatedContactsButton />}
      <ThreadHeader.Info
        css={{
          borderLeft: threadNamingIsEnabled || variant === 'small' ? `1px solid ${theme.colors.neutral10}` : undefined,
          paddingLeft: theme.spacing(1),
        }}
      />
    </span>
  );
};
